import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyBxV5IBzd-axOATNHaemB0dluM7I2jIq1g",
    authDomain: "telltipsafrica.firebaseapp.com",
    projectId: "telltipsafrica",
    storageBucket: "telltipsafrica.appspot.com",
    messagingSenderId: "863123548312",
    appId: "1:863123548312:web:8a66eb4008dea63c66c8ed",
    measurementId: "G-4C3F8T4DTB"
  };


  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);

  export default db